import React from 'react';

const Bath = (props: object) => {
  return (
    <svg
      width="12"
      height="17"
      viewBox="0 0 12 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.7076 8.51306V8.51302C11.7076 8.50834 11.7075 8.50354 11.7074 8.49865C11.7035 7.56319 11.3208 6.68471 10.6307 6.02424C10.0408 5.45959 9.28557 5.11125 8.47044 5.01986V3.9013C8.47044 3.10103 8.14252 2.3474 7.54945 1.77974C6.95651 1.21221 6.17123 0.9 5.3392 0.9H3.73041C2.89841 0.9 2.11313 1.21222 1.5202 1.77974C0.927135 2.3474 0.599219 3.10103 0.599219 3.9013V15.7217C0.599219 15.9574 0.797537 16.141 1.03285 16.141C1.26816 16.141 1.46648 15.9574 1.46648 15.7217V3.9013C1.46648 2.71299 2.47799 1.73867 3.73041 1.73867H5.3392C6.59165 1.73867 7.60318 2.71299 7.60318 3.9013V5.01986C6.78805 5.11125 6.03286 5.4596 5.44292 6.02425C4.74932 6.68812 4.36627 7.57223 4.36627 8.51306C4.36627 8.74874 4.56459 8.9324 4.7999 8.9324H11.2738H11.2738H11.2738H11.2738H11.2738H11.2738H11.2738H11.2738H11.2738H11.2738H11.2738H11.2738H11.2739H11.2739H11.2739H11.2739H11.2739H11.2739H11.2739H11.2739H11.2739H11.2739H11.2739H11.2739H11.2739H11.274H11.274H11.274H11.274C11.5093 8.9324 11.7076 8.74874 11.7076 8.51306ZM5.26783 8.09373C5.47868 6.81824 6.63728 5.83419 8.03681 5.83419C9.43636 5.83419 10.595 6.81824 10.8058 8.09373H5.26783Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
      <path
        d="M5.41371 9.23789C5.1784 9.23789 4.98008 9.42155 4.98008 9.65722V11.1488C4.98008 11.3845 5.1784 11.5681 5.41371 11.5681C5.64902 11.5681 5.84734 11.3845 5.84734 11.1488V9.65722C5.84734 9.42155 5.64902 9.23789 5.41371 9.23789ZM8.03643 9.23789C7.80112 9.23789 7.6028 9.42155 7.6028 9.65722V11.1488C7.6028 11.3845 7.80112 11.5681 8.03643 11.5681C8.27174 11.5681 8.47006 11.3845 8.47006 11.1488V9.65722C8.47006 9.42155 8.27174 9.23789 8.03643 9.23789ZM10.6591 9.23789C10.4238 9.23789 10.2255 9.42155 10.2255 9.65722V11.1488C10.2255 11.3845 10.4238 11.5681 10.6591 11.5681C10.8945 11.5681 11.0928 11.3845 11.0928 11.1488V9.65722C11.0928 9.42155 10.8945 9.23789 10.6591 9.23789Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
      />
    </svg>
  );
};

export default Bath;
